import type { FC, ReactNode } from "react";

import { SocialFacebookIcon } from "@jti/brand-icons/social-facebook";
import { SocialInstagramIcon } from "@jti/brand-icons/social-instagram";
import { SocialLineIcon } from "@jti/brand-icons/social-line";
import { SocialMailIcon } from "@jti/brand-icons/social-mail";
import { SocialSnapchatIcon } from "@jti/brand-icons/social-snapchat";
import { SocialTelegramIcon } from "@jti/brand-icons/social-telegram";
import { SocialViberIcon } from "@jti/brand-icons/social-viber";
import { SocialWhatsappIcon } from "@jti/brand-icons/social-whatsapp";
import { SocialXIcon } from "@jti/brand-icons/social-x";
import { SocialYoutubeIcon } from "@jti/brand-icons/social-youtube";
import type { CheckoutOrderSummarySocialMedia } from "@jti/commerce";
import { LinkBehaviour } from "@jti/core-components/components/LinkBehaviour";

import styles from "./SocialMedia.module.scss";

type SocialIcons = Record<string, ReactNode>;

const SOCIAL_ICONS: SocialIcons = {
  FACEBOOK: <SocialFacebookIcon className={styles.icon} aria-hidden="true" />,
  INSTAGRAM: <SocialInstagramIcon className={styles.icon} aria-hidden="true" />,
  LINE: <SocialLineIcon className={styles.icon} aria-hidden="true" />,
  MAIL: <SocialMailIcon className={styles.icon} aria-hidden="true" />,
  SNAPCHAT: <SocialSnapchatIcon className={styles.icon} aria-hidden="true" />,
  TELEGRAM: <SocialTelegramIcon className={styles.icon} aria-hidden="true" />,
  VIBER: <SocialViberIcon className={styles.icon} aria-hidden="true" />,
  WHATS_UP: <SocialWhatsappIcon className={styles.icon} aria-hidden="true" />,
  X: <SocialXIcon className={styles.icon} aria-hidden="true" />,
  YOUTUBE: <SocialYoutubeIcon className={styles.icon} aria-hidden="true" />,
};

const SOCIAL_PLATFORM_NAMES: Record<string, string> = {
  FACEBOOK: "Facebook",
  INSTAGRAM: "Instagram",
  LINE: "Line",
  MAIL: "Email",
  SNAPCHAT: "Snapchat",
  TELEGRAM: "Telegram",
  VIBER: "Viber",
  WHATS_UP: "WhatsApp",
  X: "X",
  YOUTUBE: "YouTube",
};

type SocialIconProps = {
  link: CheckoutOrderSummarySocialMedia;
};

export const SocialIcon: FC<SocialIconProps> = ({ link }) => {
  const socialIcon = SOCIAL_ICONS[link.icon];

  if (!socialIcon) {
    return null;
  }

  const ariaLabel = SOCIAL_PLATFORM_NAMES[link.icon] ?? link.icon;

  return (
    <LinkBehaviour href={link.uri} target="_blank" rel="noreferrer" aria-label={ariaLabel}>
      {socialIcon}
    </LinkBehaviour>
  );
};
